import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useLocation } from '@reach/router';
import clsx from 'clsx';
import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FancyTitle from '../fancy-title';
import * as icons from '../../icons/icon-pack';
import Container from '../Container';

export default function Perks({ blok }) {
  library.add({ ...icons });
  const styles = clsx('blok-perks');
  const location = useLocation();

  let titleLevel = blok?.title_level ? blok?.title_level.toLowerCase() : 'h2';
  if (titleLevel.startsWith('h') === false) {
    titleLevel = `h${titleLevel}`;
  }

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <Container>
        <FancyTitle
          text={blok?.title}
          className="my-10 text-left"
          tag={blok?.title_level ? blok?.title_level.toLowerCase() : 'h2'}
        />
        <div className={`grid grid-cols-2 md:grid-cols-3 ${location.pathname.includes('products/') ? 'lg:grid-cols-5 xl:grid-cols-5' : 'lg:grid-cols-3 xl:grid-cols-3'} gap-x-4 gap-y-16]`}>
          {blok.perks.map((perk) => {
            let prefix;
            let iconName;

            if (perk?.icon_title || perk?.icon[0].slug) {
              iconName = perk.icon[0].content?.icon_title || perk.icon[0].slug;
              prefix = perk.icon[0].content?.prefix || 'far';
            }

            const perkIcon = icon({ prefix, iconName });

            return (
              <div key={iconName} className="flex flex-col m-1">
                <div className="flex justify-center text-center align-center">
                  <div className="rounded-full w-[60px] h-[60px] inline-flex justify-center items-center bg-latori-green-dark mb-5 text-white">
                    {perkIcon && <FontAwesomeIcon icon={perkIcon} size="xl" />}
                  </div>
                </div>
                <p
                  className="mb-5 text-base font-semibold text-center break-words"
                  dangerouslySetInnerHTML={{ __html: perk.title }}
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
}
